<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>4. {{ $t('earthingUnit') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarPresentState') }}</div>
        <div>{{ $t(project.serviceReport.equipotentialBusBarPresentState) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('secondaryEquipotentialBusBarPresentState') }}</div>
        <div>{{ $t(project.serviceReport.secondaryEquipotentialBusBarPresentState) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('potentialGroundRodPresentState') }}</div>
        <div>{{ $t(project.serviceReport.potentialGroundRodPresentState) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('potentialGroundRodPresentState') }}</div>
        <div>{{ $t(project.serviceReport.potentialGroundRodPresentState) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('earthingSupply16mmState') }}</div>
        <div>{{ $t(project.serviceReport.earthingSupply16mmState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.serviceEarthingAttachments"
      fieldName="serviceEarthingAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'EarthingUnitPrintPage',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
